import { DiscardDraftAlert } from '@/features/moderation/DiscardDraftAlert'
import { useHasUnsavedBlockDraft } from '../studio/aiSidebar/useUnsavedBlockGate'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

/** Подтверждение `DELETE …/draft` черновика курса.
 *  Читает `isDirty` открытого блока — поэтому обязан стоять внутри `BlockDraftProvider`,
 *  иначе хук видит дефолт контекста и строка о несохранённом экране молчит.
 *  Строка говорит то, что случится на деле: после отмены `useReadSourceRemap` + `syncDraft`
 *  переносят на живой блок только НЕСОХРАНЁННУЮ разницу экрана (`carryDiff` — поля,
 *  разошедшиеся с основой черновика; отменённый текст черновика не возвращается), правка
 *  остаётся несохранённой, а блок, которого нет в живой версии, исчезает вместе с ней. */
export const DiscardDraftDialog = ({ open, onOpenChange, onConfirm }: Props) => {
  const m = useMessages(messages)
  const hasUnsavedBlock = useHasUnsavedBlockDraft()
  return (
    <DiscardDraftAlert
      open={open}
      onOpenChange={onOpenChange}
      onConfirm={onConfirm}
      subject={m.discardSubject}
      note={
        hasUnsavedBlock ? <p className="text-sm text-muted-foreground">{m.discardNote}</p> : null
      }
    />
  )
}
